import { ready, withEl, createNode } from '@front/utils';
import prestashop from 'prestashop';

export const reload = async () => {
    // Mise à jour du contenu dynamique en ajax - la homepage, les pages catégories, les pages produit, les pages CMS et le blog sont misent en cache par Varnish
    // Voir le controller `override/controllers/front/DynamicDataController.php` pour les datas retournées

    if (prestashop?.page?.need_dynamic_data != true) {
        return;
    }

    let data = new FormData();

    // recupération informations produits si on est sur une page produit
    const element = document.querySelector('#product .js-product-actions');
    if(element) {

        const idProduct = <HTMLInputElement> element.querySelector('input[name=id_product]');
        if(idProduct) {
            data.append('id_product', idProduct.value);

            const idProductAttribute = <HTMLInputElement> element.querySelector('input[name=idProductAttribute]');
            if(idProductAttribute) {
                data.append('id_product_attribute', idProductAttribute.value);
            }

            const idCustomization = <HTMLInputElement> element.querySelector('input[name=idCustomization]');
            if(idCustomization) {
                data.append('id_customization', idCustomization.value);
            }
        }

    }

    // recupération informations store si on est sur une page magasin
    const store = document.querySelector('#stores meta[name="store"]') as HTMLMetaElement;
    if(store) {
        const storeInfos = JSON.parse(store.content);
         data.append('id_store', storeInfos.id_store);
    }

    let url = prestashop.urls.base_url;
    if(Object.keys(prestashop.urls.alternative_langs).length > 1) {
        url += prestashop.language.iso_code + '/';
    }

    const response = await fetch(url + 'dynamic-data', {
        method: 'POST',
        body: data,
        headers: {
            'Accept': 'application/json',
        },
    });

    const json = await response.json();

    prestashop.emit('dynamic-data', json);
}

prestashop.on('dynamic-data', data => {
    // Replace templates with dynamic content
    Object.entries(data?.templates || {})
        .filter(([template, html]) => html)
        .forEach(([template, html]) => {
            const node = createNode(html as string);
            withEl(`.js-dynamic-data-template-${template}`, el => {
                const newNode = node.querySelector(`.js-dynamic-data-template-${template}`) || node;
                el.replaceWith(newNode);
            });
        });

    // Fix comparaison produits
    withEl('.cdpcp__item', el => {
        withEl('#cdproductcomparisonplus', el => el.style.display = 'block');
    });
});

ready(reload);
